<div class="d-flex flex-column justify-content-center align-items-center" *transloco="let t">
  <div class="icon-holder">
    <i class="{{iconClasses() ?? 'fa-solid fa-unlock-alt'}}"></i>
  </div>
  @let titleTextVariable = titleText();
  @let titleTranslationKeyVariable = titleTranslationKey();
  @let descriptionTextVariable = descriptionText();
  @let descriptionTranslationKeyVariable = descriptionTranslationKey();
  @if(titleTextVariable || titleTranslationKeyVariable) {
    <p class="title h5 font-weight-bold mt-3">{{ titleTranslationKeyVariable ? t(titleTranslationKeyVariable) : titleTextVariable }}</p>
  }
  @if (descriptionTranslationKeyVariable || descriptionTextVariable) {
    <p class="mb-2">{{ descriptionTranslationKeyVariable ? t(descriptionTranslationKeyVariable) : descriptionTextVariable }}</p>
  }
  @let ctaTextVariable = cta_text();
  @let ctaTranslationKeyVariable = cta_translationKey();
  <button type="button" [class]="ctaButtonClasses()" [class.w-auto]="smallButton()" (click)="doLockLinkClick()">
    {{ctaTranslationKeyVariable ? t(ctaTranslationKeyVariable) : ctaTextVariable }}
    <i class="fa-solid fa-arrow-right ml-2"></i>
  </button>
</div>